import comp from "/home/runner/work/docs/docs/src/.vuepress/.temp/pages/docs/devices.html.vue"
const data = JSON.parse("{\"path\":\"/docs/devices.html\",\"title\":\"Device Support Status\",\"lang\":\"en-US\",\"frontmatter\":{},\"headers\":[],\"git\":{\"updatedTime\":1774655546000},\"filePathRelative\":\"docs/devices.md\"}")
export { comp, data }
